// extracted by mini-css-extract-plugin
export default {"autoScale":"veVzWj"};